const dataGridStyle = {
    root: {
      "& .MuiDataGrid-root": {
        borderRadius: '10px',
        backgroundColor: 'white',
        fontSize: '12px',
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: '#a5d6a7',
        // color: 'white',
        fontSize: '15px',
      },
    },
  };
  
  export default dataGridStyle;